import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {SettingsParkingLot} from '../../../types/data.types';
import {SettingsParkingPassesService} from '../../../services/settings-parking-passes.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'settings-parking-lot-modal',
    templateUrl: './settings-parking-lot-modal.component.html',
    styleUrls: ['./settings-parking-lot-modal.component.scss']
})
export class SettingsParkingLotModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    data: SettingsParkingLot = new SettingsParkingLot();
    disabledSubmit = false;
    disabledFileInput = false;
    attachments: Array<any> = [];
    disabledDates: Array<any> = [];
    startDate = null;
    endDate = null;
    multiselectSettings = {
        singleSelection: false,
        text: 'Select',
        selectAllText: 'Select All',
        unSelectAllText: 'Deselect All',
        enableSearchFilter: true
    };
    uses = [''];

    constructor(public api: ApiClientService,
                public settingsParkingPassesService: SettingsParkingPassesService,
                public urlService: UrlService) {
    }

    ngOnInit() {
        setTimeout(() => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.settingsParkingPassesService.showCreateModal = false;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.settingsParkingPassesService.showCreateModal = false;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!form.value.name) toastr.warning('Name should not be blank.');
            if (!form.value.buildings || form.value.buildings.length == 0) toastr.warning('Buildings should not be blank.');
            return;
        }
        const name = form.value.name;
        const buildings = form.value.buildings;

        if (!name) {
            toastr.warning('Name is not set.');
            return;
        }
        if (!buildings || buildings.length == 0) {
            toastr.warning('Buildings are not set.');
            return;
        }

        const data: any = {
            name: form.value.name,
            internalId: form.value.internalId,
            building: this.buildingParkingPassFormatConvertion(this.data.building),
        };

        this.disabledSubmit = true;

        this.api.post('domainParkingPass', '/v1/parking_lot.json', data).subscribe(
            () => this.updateView('Parking Lot successfully created'),
            error => {
                this.disabledSubmit = false;
                this.api.errorHandler(error, 'Create Parking Lot failed');
            }
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.settingsParkingPassesService.getData();
        this.form.reset();
        this.hideModal();
    }

    trackByFn(index, item) {
        return index; // or item.id
    }

    buildingParkingPassFormatConvertion(buildings): any {
        return buildings.map((b) => ({
                   buildingId: b.id,
                   buildingName: this.getBuildingNameById(b.id),
                   timezone: b.timeZone
               }));
    }

    getBuildingNameById(id): string {
        let name = '';

        this.settingsParkingPassesService.buildings.filter(building => {
            if (building.id == id)
                name = building.name;
        });

        return name;
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-parking-passes/settings-parking-lot-modal/settings-parking-lot-modal.component.ts